import { UNIVERSITYPLAN } from '../enums/planType';
import { universityRestriction } from '../universityRestrictions';
import placeholders from '../../components/userDocuments/editDocument/editResume/EditSpace/EditorPane/RenderContent/EditorSection/placeholders';

const customPlaceHolders = ({
  sectionKey,
  type,
  selectedPlan,
  universityPlan,
}: {
  sectionKey: string;
  type: string;
  selectedPlan: string;
  universityPlan: {
    code: string;
  } | null;
}) => {
  if (
    selectedPlan === UNIVERSITYPLAN &&
    universityPlan?.code &&
    type &&
    sectionKey &&
    universityRestriction?.[universityPlan?.code]?.editor?.resume?.[
      sectionKey
    ]?.[type]?.placeholder
  ) {
    return universityRestriction[universityPlan?.code]?.editor?.resume?.[
      sectionKey
    ]?.[type].placeholder;
  }
  return placeholders[type];
};

export default customPlaceHolders;
